// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle opacity=\".3\" cx=\"12\" cy=\"12\" r=\"12\"/><circle cx=\"12\" cy=\"12\" r=\"6\"/></svg> ";
// Exports
module.exports = code;